import { BrightcovePlayer } from '@brightcove/react-player-loader';
import isNil from 'lodash-es/isNil';
import { MediaPlayerError } from '@yi/core';

import { nr, isSSR } from '~/common';

import { consumedSecondsPlugin } from './consumedSecondsPlugin';
import { ExtendedBrightcovePlayer } from '../../../types';

const PLUGIN_NAME = 'consumedSecondsPlugin';
function isExtendedPlayer(
  player: BrightcovePlayer | ExtendedBrightcovePlayer,
): player is ExtendedBrightcovePlayer {
  return !isNil((player as any)?.consumedSecondsPlugin);
}

export function initializeVideoJSConsumedSecondsPlugin(
  player: BrightcovePlayer | ExtendedBrightcovePlayer,
) {
  if (isSSR()) {
    return;
  }

  if (isNil(window.videojs)) {
    nr.noticeError(new MediaPlayerError(`videojs is not initialized windowly`));
    return;
  }

  registerVideoJSConsumedSecondsPlugin();

  if (isExtendedPlayer(player)) {
    player[PLUGIN_NAME]();
  } else {
    nr.noticeError(new MediaPlayerError(`Plugin initialization failed`));
  }
}

function registerVideoJSConsumedSecondsPlugin() {
  const registeredPlugins = window.videojs.getPlugins();
  if (isNil(registeredPlugins[PLUGIN_NAME])) {
    window.videojs.registerPlugin(PLUGIN_NAME, consumedSecondsPlugin);
  }
}
